// testimonials.js

import { Link } from "react-router-dom";
import Slider from "react-slick";
import TestimonialCard from "../../02-molecules/testimonialCard/TestimonialCard"

const Testimonials = (props) => {
    const { dataArray, assetsArray, handleLoading } = props;

    // Filtering data to get an array of Testimonials
    const testimonialsArray = dataArray.filter((data) => data.fields.contentType.toLowerCase() === 'testimonials');

    // Mapping products and associating them with their images
    const testimonialAssetArray = testimonialsArray.map((testimonial) => ({
        testimonial,
        image: assetsArray.filter((asset) => testimonial.fields.reviewerName.toLowerCase() === asset.fields.title.toLowerCase()),
    }));
    
    // settings for testimonials slider
    const testimonialsSlider = {
        // dots: true,
        // arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        speed: 1000,
        centerMode: true,
        autoplay: true,
        // lazyLoad: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                centerPadding: '40px',
                }
            },

            {
                breakpoint: 650,
                settings: {
                slidesToShow: 1,
                centerPadding: '80px',
                }
            },

            {
                breakpoint: 450,
                settings: {
                slidesToShow: 1,
                centerPadding: '20px',
                }
            },
        ]
    }; 

    return(
        <section id="testimonials" className="testimonials">
            <div className="testimonials-container">
                <div className="testimonials-container__heading section-heading">
                    <h1>TESTIMONIALS</h1>
                </div>

                <div className="testimonials-container__slider">
                    <Slider {...testimonialsSlider}>
                        {testimonialAssetArray.map((review) => {
                            return (
                                <TestimonialCard key={review.testimonial.sys.id} review={review} isHomePage={true} handleLoading={handleLoading} />
                            )
                        })}
                    </Slider>
                </div>

                <Link to="/testimonials">
                    <button className="primary-button testimonials-container__button">View All Testimonials</button>
                </Link>
            </div>
        </section>
    )
}

export default Testimonials;